import type { PropertyId, SalesInvoiceId } from '@previo/codebooks'
import type { RouteParams } from 'vue-router'

type Path = string

export type PathParams = Record<string, string | number>

export type PathQueryValue = string | null | boolean | number | string[] | number[]

export type PathQuery = Record<string, PathQueryValue>

export function resolveFullPath(
  path: Path,
  params: PathParams | RouteParams,
  query: PathQuery,
): string {
  const result: string = path.replace(/:(\w+)/g, (match: string, key: string): string => {
    return (params[key] || match).toString()
  })

  if (Object.keys(query).length <= 0) {
    return result
  }

  return `${result}?${queryToString(query)}`
}

export function resolveP1Url(
  p1Path: Path,
  params: PathParams | RouteParams = {},
  query: PathQuery = {},
): string {
  return `${import.meta.env.CRM_FE_P1_APP_URL}${resolveFullPath(p1Path, params, query)}#/`
}

export function resolveP1PropertyDetailUrl(propertyId: number): string {
  return resolveP1Url('/hotels/details/:propertyId', { propertyId })
}

export function resolveP1PropertySalesInvoicesUrl(propertyId: PropertyId): string {
  return resolveP1Url('/sales/invoices', {}, { hotId: propertyId })
}

export function resolveP1SalesInvoicePdfUrl(salesInvoiceId: SalesInvoiceId): string {
  return resolveP1Url('/sales/export-invoice/sliId/:salesInvoiceId', { salesInvoiceId })
}

function queryToString(query: PathQuery): string {
  const queryWithoutArrayValues: Record<string, string> = {}

  const queryArrayValues: string[] = []

  Object.keys(query).forEach((key: string): void => {
    const val: PathQueryValue = query[key]

    if (Array.isArray(val)) {
      val.forEach((value: string | number): void => {
        queryArrayValues.push(`${key}[]=${value}`)
      })
    } else {
      queryWithoutArrayValues[key] = query[key] as string
    }
  })

  const queryStringWithoutArrayValues: string = new URLSearchParams(
    queryWithoutArrayValues,
  ).toString()

  if (queryArrayValues.length > 0) {
    return `${queryStringWithoutArrayValues}&${queryArrayValues.join('&')}`
  }

  return queryStringWithoutArrayValues
}
